import "./style.scss"
import ErrorDisplay from "../errorDisplay";

let idx = 0;

const Textarea = (props) => {
  const {
    name,
    id,
    label,
    placeholder,
    value,
    rows,
    cols,
    changeAction,
    onKeyDown,
    errors,
    autoComplete,
    autoFocus,
    disabled,
    focusOnError
  } = props;

  const idValue = id || label || name;
  const hasError = Boolean(errors?.length);
  const errorId = 'error-' + idx++;

  return (
    <div className='form-textarea'>
      <label htmlFor={idValue}>{label || name || id}</label>
      <textarea
        className={hasError ? 'error' : ''}
        id={idValue}
        name={name}
        defaultValue={value}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        cols={cols}
        aria-describedby={hasError ? errorId : null}
        autoFocus={autoFocus}
        onChange={(e) => {
          e.preventDefault();
          changeAction(e.target.value);
        }
        }
        onKeyDown={onKeyDown || null}
      />
      { hasError && <ErrorDisplay shouldFocus={focusOnError} errors={errors} id={errorId}/> }
    </div>
  );
}

export default Textarea;